import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../contexts/auth';
import { apiClient } from '../lib/api-client';

export type CurrentUserInformation = {
	userName: string,
	companyID: number,
	firstName: string,
	lastName: string,
	fullName: string,
	emailAddress: string,
	phone: string,
	groups: string[],
	inactive: boolean,
	imageUrl: string,
	maxInactivityDays: string
}

export const useGetCurrentUserInformation = () => {

	const { user } = useAuth();
	const { data, isLoading } = useQuery({
		queryKey: ['current-user', user?.userName],
		queryFn: async () => await apiClient.get('user/current') as CurrentUserInformation
	});

	return {
		data, isLoading
	};
};
